module.exports = __webpack_public_path__ + "static/media/silhueta_wide.8541cef6.png";